const CENTERED_PARKING_NUM = 7

type LatLngLiteral = {
    lat: number,
    lng: number,
}

export function getSearchBounds ({ latitude, longitude }) {
    const bounds = new window.google.maps.LatLngBounds()

    if (!latitude || !longitude) {
        return bounds
    }

    return bounds.extend({
        lat: latitude,
        lng: longitude,
    })
}

export function getMapCenter (map): LatLngLiteral {
    return map.getCenter().toJSON()
}

export function getBoundsCenter (bounds): LatLngLiteral {
    return bounds.getCenter().toJSON()
}

export function getParkingBounds (parkings, center) {
    const bounds = new window.google.maps.LatLngBounds()
    bounds.extend(center)
    return parkings.slice(0, CENTERED_PARKING_NUM).reduce((bounds, parking) => (
        bounds.extend({
            lat: parking.latitude,
            lng: parking.longitude,
        })
    ), bounds)
}
